import { render } from "./viewcompterimage.vue?vue&type=template&id=5d962a90"
import script from "./viewcompterimage.vue?vue&type=script&lang=js"
export * from "./viewcompterimage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__